import { Component } from '@angular/core';
import { NbThemeService } from '@nebular/theme';
import { ConfigService } from './services/config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'cms';

  constructor(public themeService: NbThemeService, private configService: ConfigService) {
    this.configService.init();
    const theme = localStorage.getItem('theme') || 'dark';
    this.themeService.changeTheme(theme);
  }

  async ngOnInit(): Promise<void> {}
}
